// Import styles
import "../scss/main.scss";

// Import main JavaScript functionality
import "../js/main.js";

console.log("Cash'd website loaded successfully!");
